module.exports = __webpack_public_path__ + "img/WATCH.59341b32.png";